export default {
  namespaced: true,

  state: {
    selectedTheme: {},
    recentCustomColors: (() => {
      try {
        const s = JSON.parse(window.localStorage.getItem('recentCustomColors') || '[]');
        return Array.isArray(s) ? s : [];
      } catch {
        return [];
      }
    })(),
  },

  getters: {
    selectedTheme: state => _.isEmpty(state.selectedTheme)
      ? null
      : state.selectedTheme,
    recentCustomColors: (state) => state.recentCustomColors,
  },

  mutations: {
    SET_SELECTED_THEME (state, payload) {
      state.selectedTheme = payload
    },
    ADD_COLOR(state, { color, palette }) {
      if (!color) return;
      if (Array.isArray(palette) && palette.includes(color)) return; // skip built‑ins
      let recents = state.recentCustomColors.filter(c => c !== color);
      recents.unshift(color);
      if (recents.length > 5) recents = recents.slice(0, 5);
      state.recentCustomColors = recents;
      window.localStorage.setItem('recentCustomColors', JSON.stringify(recents));
    },
  },

  actions: {
    addRecentCustomColor({ commit }, payload) {
      commit('ADD_COLOR', payload);
    },
  },
}
